import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {AgenciesService, UpdateAgentModel, AddAgentModel, UpdateAgencyModel } from 'src/app/Api_Module';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-create-agent-modal',
  templateUrl: './create-agent-modal.component.html',
})
export class CreateAgentModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() agency: UpdateAgencyModel;
  @Input() agent: UpdateAgentModel | AddAgentModel;
  agentId: number;
  @Output() success: EventEmitter<any> = new EventEmitter();
  titles: string[];
  loading: boolean;
  alert: any;
  updateMode: boolean;

  constructor(private modalService: NgbModal, private agenciesService: AgenciesService, private toastr: ToastrService) { }

  ngOnInit() {
  }

  openLg(content) {
    if (!!this.agent && !!this.agent['id'] && this.agent['id'] > 0) {
      this.updateMode = true;
    } else {
      this.agent = {name: '', email: '', surname: '', agencyId: this.agency.id};
      this.updateMode = false;
    }
    this.modalService.open(content, { size: 'lg' });
  }

  create() {
    this.agenciesService.addAgent('' + this.agency.id, this.agent as AddAgentModel).subscribe((resp) => {
      this.loading = false;
      this.agentId = resp;
      this.success.emit({selected: [this.agency]});
      this.toastr.success('Agent created');
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.agentId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  update() {
    const agentReq: UpdateAgentModel = this.agent;
    agentReq.agencyId = this.agency.id;
    this.agenciesService.updateAgent('' + agentReq.id, agentReq).subscribe((resp) => {
      this.loading = false;
      this.agentId = resp;
      this.toastr.success('Agent updated');
      this.success.emit({selected: [this.agency]});
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.agentId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  close(alert: any) {
    this.alert = null;
  }
}
